import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { format, isPast, parseISO } from 'date-fns'
import { useState } from 'react'
import { CurrentUser } from '../../../model/Common/common.interface'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_common, n_content, n_event, n_rwm } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { IInitialData } from './types'

export interface PopupProps {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  content: string
  onConfirm?: () => void
  type: string
}
export interface IContentPurchase {
  success: boolean
  message: string
  content_program_purchase: ContentProgramPurchase
}

export interface ContentProgramPurchase {
  id: number
  user_id: number
  content_program_id: number
  amount: number
  method: string
  checkout: boolean
  payment_key: null
  pg_provider: null
  receipt_url: null
  created_at: Date
  updated_at: Date
  merchant_uid: string
}

export interface IPurchasePayload {
  sanity_content_type: string
  sanity_id: string
  transaction_type: string
  amount: number
  currency: string
}

export interface IContentProgramPurchase {
  success: boolean
  message: string
  content_program_purchase: ContentProgramPurchase
}

export interface ContentProgramPurchase {
  id: number
  user_id: number
  content_program_id: number
  amount: number
  method: string
  checkout: boolean
  payment_key: null
  pg_provider: null
  receipt_url: null
  created_at: Date
  updated_at: Date
  merchant_uid: string
}

export interface IPaymentPayload {
  purchase_id: number
  currentUser: CurrentUser
  merchant_uid: string
}
export const PAYMENT_GATEWAY_TYPE = {
  UPLUS: 'uplus',
}
export const PAYMENT_METHOD = {
  CARD: 'card',
}

export const POPUP_TYPE = {
  FAIL: 'fail',
  SUCCESS: 'success',
  LOGIN: 'login',
  SELECT_PAYMENT: 'select_payment',
  INTER_NATIONAL_PAYMENT: 'international_payment',
}

export function convertDate(inputDate) {
  const date = new Date(inputDate)

  const formattedTime = format(date, 'h:mm a')

  const formattedDate = format(date, 'yyyy.M.d') + ` ${formattedTime}`

  return formattedDate
}

export const isEnded = (endDateStr) => {
  const endDate = parseISO(endDateStr)

  return isPast(endDate)
}

export const getSessionNumb = (dateList) => {
  let numb = 0
  dateList?.forEach((item) => {
    if (isPast(new Date(item))) {
      numb++
    }
  })
  if (dateList && numb + 1 > dateList?.length) return 0

  return numb + 1
}

export const getButtonAttributes = ({
  t,
  isActive,
  isEndedEvent,
  isEndedDueDate,
  enrolled,
  link,
  handleApplyButton,
  currentUser,
  session,
  handleLoginButton,
  path,
  isReadTogether,
  isBeforeStart,
  handleEnter,
}) => {
  const createButtonAttributes = (label, disabled, onClick = null) => ({
    label,
    disabled,
    onClick,
  })
  if (path.includes('/landing/')) {
    if (!currentUser) return createButtonAttributes(t(n_content.rwm.btn), false, () => handleLoginButton())
  }

  if (isEndedEvent) {
    return createButtonAttributes(t(n_content.btn.enter), true)
  }
  if (isReadTogether) {
    if (enrolled) {
      if (isActive && link) {
        return createButtonAttributes(t(n_content.btn.end), false, () => handleEnter(link))
      }
      if (session === 0) {
        return createButtonAttributes(t(n_content.btn.enter), true)
      }

      return createButtonAttributes(t(n_content.btn.session_upcoming), true)
    }

    if (isEndedDueDate) {
      return createButtonAttributes(t(n_content.btn.enroll_finished), true)
    }

    return createButtonAttributes(t(n_content.rwm.btn), false, (e) => handleApplyButton(e, currentUser))
  } else {
    if (enrolled) {
      if (isBeforeStart) {
        return createButtonAttributes(t(n_content.btn.program_will_going), true)
      }
      if (!isEndedEvent) {
        return createButtonAttributes(t(n_content.btn.program_ongoing), true)
      }
    }

    if (isEndedDueDate) {
      return createButtonAttributes(t(n_content.btn.enroll_finished), true)
    }

    return createButtonAttributes(t(n_content.rwm.btn), false, (e) => handleApplyButton(e, currentUser))
  }
}

export const checkApplicationStatus = (referenceTime) => {
  const currentTime = new Date()
  const refTime = new Date(referenceTime)

  if (currentTime < refTime) {
    return true
  } else {
    return false
  }
}
export const usePopup = () => {
  const [popup, setPopup] = useState({
    show: false,
    title: '',
    message: '',
    type: '',
    showNotiButton: false,
    onConfirm: null,
  })

  const openPopup = (options) => setPopup({ ...popup, show: true, ...options })
  const closePopup = () => setPopup({ ...popup, show: false, title: '', message: '', type: '' })

  return { popup, openPopup, closePopup }
}

export interface IContentDetailPurchaseButton {
  initialData: IInitialData
  isActive: boolean
  isRWM: boolean
}

export const UnifiedPopup: React.FC<PopupProps> = ({ isOpen, setIsOpen, title, content, onConfirm, type }) => {
  const { closePopup } = usePopup()
  const { t } = useTranslation()
  const router = useAppRouter()

  return (
    <DSModal id="unified-popup" isOpen={isOpen} setIsOpen={setIsOpen} size="lg" closeButton={true}>
      <DSModal.Title>{title}</DSModal.Title>
      <DSModal.Content>{content}</DSModal.Content>
      {type != POPUP_TYPE.SELECT_PAYMENT && type != POPUP_TYPE.INTER_NATIONAL_PAYMENT && (
        <DSModal.ButtonContainer direction="horizontal">
          {type === POPUP_TYPE.LOGIN && (
            <DSButton
              type={BUTTON_TYPE.OUTLINE}
              size={BUTTON_SIZE.LG}
              onClick={() => {
                setIsOpen(false)
                closePopup()
              }}
            >
              <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
            </DSButton>
          )}
          {type === POPUP_TYPE.SUCCESS && (
            <DSButton
              type={BUTTON_TYPE.OUTLINE}
              size={BUTTON_SIZE.LG}
              onClick={() => {
                setIsOpen(false)
                closePopup()
                router.push(urls.student.newPortal.mypage.notification)
              }}
            >
              <DSButton.Label>{t(n_rwm.modal_ss_done.btn)}</DSButton.Label>
            </DSButton>
          )}
          <DSButton
            size={BUTTON_SIZE.LG}
            onClick={() => {
              if (onConfirm) onConfirm()
              setIsOpen(false)
              closePopup()
            }}
          >
            <DSButton.Label>{t(n_common.btn_ok)}</DSButton.Label>
          </DSButton>
        </DSModal.ButtonContainer>
      )}
    </DSModal>
  )
}

export const getProgramStatus = ({ t, isAvailable, isEnrolled, isFinished, isBeforeDueDate }) => {
  if (isEnrolled) {
    if (isAvailable) {
      return (
        // 진행예정
        <div className="Caption-12Bd rounded-[4px] bg-blue-50 px-[6px] pt-[2px] text-blue-600">
          {t(n_rwm.program_label.upcoming)}
        </div>
      )
    } else if (isFinished) {
      return (
        // 진행종료
        <div className="Caption-12Bd rounded-[4px] bg-gray-100 px-[6px] pt-[2px] text-gray-600">
          {t(n_rwm.program_label.completed)}
        </div>
      )
    } else {
      return (
        // 진행중
        <div className="Caption-12Bd rounded-[4px] bg-green-50 px-[6px] pt-[2px] text-green-600">
          {t(n_rwm.program_label.inprogress)}
        </div>
      )
    }
  } else {
    if (isBeforeDueDate) {
      return (
        // 신청가능
        <div className="Caption-12Bd rounded-[4px] bg-blue-50 px-[6px] pt-[2px] text-blue-600">
          {t(n_content.label_available)}
        </div>
      )
    } else {
      return (
        // 신청 마감
        <div className="Caption-12Bd rounded-[4px] bg-blue-50 px-[6px] pt-[2px] text-blue-600">
          {t(n_event.card.label_6)}
        </div>
      )
    }
  }
}
